export type CountryCode = "US" | "CA";

export const isCountryCode = (code: unknown): code is CountryCode =>
  code === "US" || code === "CA";
